import { async } from "@firebase/util";
import { useState, useContext } from "react";
//import { createUserDocumentFromAuth , signInAuthUserWithEmailAndPassword } from "../../../utils/firebase/firebase.util";
import FormInput from "../../form-input/form-input.component";
import './sign-in-form-style.scss'
import Button,{Button_Type_Classes} from "../../button/button.component";
import { useDispatch } from "react-redux";
// import { UserContext } from "../../../contexts/user.context";
import { useSelector } from "react-redux";
// import { setCurrentUser  } from "../../../store/user/user.action";
import { googleSignInStart, emailSignInStart } from "../../../store/user/user.action";
const defaultFormFields={
    
    email:'',
    password:'',
    
}

const SignInForm=()=>{
    const dispatch=useDispatch()
    const [formFields,setFormFields]=useState(defaultFormFields)
    const {email,password}=formFields

    // const setCurrentUser=useSelector(setCurrentUser)

    const resetFormFields=()=>{
        setFormFields(defaultFormFields)
    }

    const SignInWithGoogle =async()=>{
        // await signInWithGoogleopopup();
        dispatch(googleSignInStart())
        
       
    }
    

    
    const handleSubmit=async(event)=>{
        event.preventDefault();
        
        
        try{
            // const {user}= await signInAuthUserWithEmailAndPassword(email,password)
            dispatch(emailSignInStart(email,password))
            resetFormFields();
        }catch(error){
            switch(error.code){
                case 'auth/wrong-password':
                    alert('Incorrect password for email')
                    break;
                case 'auth/user-not-found':
                    alert('no user associated with this email')
                    break;
                default:
                    
            }
          
            
            // if (error.code === "auth/wrong-password"){
            //     alert('Incorrect password for email')
            // } else if(auth/user-not-found)

        }
    }
    const handleChange=(event)=>{
        const {name,value}=event.target;
        setFormFields({...formFields,[name]:value})


    };


    


    return (
        <div className="sign-up-container">
            <h2>Already have an account</h2>
            <span>Sign up with your Email and Password</span>
            <form onSubmit={handleSubmit}>
                
              
                
                <FormInput label='Email' type='email' required onChange={handleChange} name='email' value={email} />
               
                <FormInput label='password' type='password' required onChange={handleChange} name='password' value={password} />
                
                <div className="buttons-container">
                    <Button buttonType='inverted' type='submit'>Sign In</Button>
                
                 <Button type='button' buttonType={Button_Type_Classes.google} onClick={SignInWithGoogle} >Google Sign-In</Button>
                </div>
                
            </form>
        </div>
    )
}
export default SignInForm;